import { render, staticRenderFns } from "./Hlas.vue?vue&type=template&id=1c1325d2"
import script from "./Hlas.vue?vue&type=script&lang=ts"
export * from "./Hlas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports